module.exports = __webpack_public_path__ + "static/media/instagram.f3fbb6da.svg";